import { buildPayloadApiUrl, payloadFetch } from "./client";

const DEFAULT_TIMEOUT_MS = 3000;

export function isValidSeoEntry(entry) {
  if (entry === null || typeof entry !== "object" || Array.isArray(entry)) {
    return false;
  }

  const requiredFields = ["title", "description"];
  if (
    requiredFields.some(
      (field) => typeof entry[field] !== "string" || entry[field].trim() === ""
    )
  ) {
    return false;
  }

  return ["keywords", "image"].every(
    (field) =>
      entry[field] === undefined ||
      (typeof entry[field] === "string" && entry[field].trim() !== "")
  ) && (entry.noindex === undefined || typeof entry.noindex === "boolean");
}

export function filterValidSeoMap(value) {
  if (value === null || typeof value !== "object" || Array.isArray(value)) {
    return {};
  }

  return Object.fromEntries(
    Object.entries(value).filter(([, entry]) => isValidSeoEntry(entry))
  );
}

/**
 * Fetches the flat route-key SEO map from Payload CMS.
 * @param {string} locale - i18n language (`en` | `fr`)
 * @returns {Promise<Record<string, Object>>}
 */
export async function fetchSeoMap(locale) {
  const normalizedLocale = locale === "fr" ? "fr" : "en";
  const url = buildPayloadApiUrl("/api/seo-map", {
    locale: normalizedLocale,
  });
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), DEFAULT_TIMEOUT_MS);

  try {
    const data = await payloadFetch(url, { signal: controller.signal });
    const seoMap = filterValidSeoMap(data);
    if (Object.keys(seoMap).length === 0) {
      throw new Error("Invalid Payload SEO map");
    }
    return seoMap;
  } finally {
    clearTimeout(timeout);
  }
}